module.exports = __webpack_public_path__ + "img/discord.2ca4611a.svg";